import useResignationAction from '../hooks/useResignationAction'
import useResignationData from '../hooks/useResignationData'
import WarehouseGuard from '../core/WarehouseGuard'
import { useParams } from 'react-router-dom'
import { Action, Step } from '../core/utils'
import Loading from 'components/Loading'
import React, { useState } from 'react'
import Camera from '../core/Camera'
import Final from '../core/Final'
import Summary from './Summary'
import Default from './Default'

interface Params {
  id: string
  action: Action
}

const MagCancelContent: React.FC = () => {
  const { action } = useParams<Params>()
  const [step, setStep] = useState<Step>('init')
  const [deliveries, setDeliveries] = useState<payments.Delivery[]>([])
  const { response, selectedData, selectData } = useResignationData('cancel', 'finishRenting', deliveries)
  const { isSending, sendResignation } = useResignationAction('cancel', selectedData, deliveries, setStep)

  return (
    <div className='menu__section menu__resignation'>
      {(() => {
        switch (step) {
          case 'finish': return <Final />
          default: {
            switch (action) {
              case 'camera': return <Camera
                selectedData={selectedData}
                selectData={selectData}
              />

              case 'summary': return <Summary
                response={response}
                selectedData={selectedData}
                selectData={selectData}
              />

              default: return response
                ? <Default
                  response={response}
                  isSending={isSending}
                  deliveries={deliveries}
                  selectedData={selectedData}
                  setDeliveries={setDeliveries}
                  sendResignation={sendResignation}
                  selectData={selectData}
                />
                : <div className='resignation__main'>
                  <Loading middleOfPage />
                </div>
            }
          }
        }
      })()}
    </div>
  )
}

const MagCancel: React.FC = () => (
  <WarehouseGuard>
    <MagCancelContent />
  </WarehouseGuard>
)

export default MagCancel